var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 37.3408V33.8408C29.75 31.9843 29.0125 30.2038 27.6997 28.8911C26.387 27.5783 24.6065 26.8408 22.75 26.8408H8.75C6.89348 26.8408 5.11301 27.5783 3.80025 28.8911C2.4875 30.2038 1.75 31.9843 1.75 33.8408V37.3408",
    stroke: "#721BE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 19.8408C19.616 19.8408 22.75 16.7068 22.75 12.8408C22.75 8.97483 19.616 5.84082 15.75 5.84082C11.884 5.84082 8.75 8.97483 8.75 12.8408C8.75 16.7068 11.884 19.8408 15.75 19.8408Z",
    stroke: "#721BE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 37.3408V33.8408C40.2488 32.2898 39.7326 30.7831 38.7824 29.5573C37.8322 28.3315 36.5017 27.456 35 27.0683",
    stroke: "#721BE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6.0683C29.5057 6.45383 30.8403 7.32953 31.7934 8.55734C32.7464 9.78516 33.2637 11.2953 33.2637 12.8495C33.2637 14.4038 32.7464 15.9139 31.7934 17.1418C30.8403 18.3696 29.5057 19.2453 28 19.6308",
    stroke: "#721BE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.a32e1608475525a9781d7c5828f2be5b.svg";
export { ForwardRef as ReactComponent };